export const TEXTO_DE_LA_NOTA_DE_TERRENO =
  "Creada en la App de terreno, sin datos de valorización. Ábrala para completarla a partir de estos registros.";

/**
 * La nota de la fila expandida cuando nació en la App de terreno y todavía no
 * tiene lo que la web valoriza.
 *
 * Es el ÚNICO mensaje de ese estado: reemplaza al texto suelto que cada línea
 * de terreno traía por su cuenta ("Completa la valorización con sus fotos y
 * audios"), que decía lo mismo con otras palabras.
 */
export function NotaDeCreadaEnTerreno({ className }: { className?: string }) {
  return (
    <p
      role="note"
      className={
        className ??
        "bg-info-soft text-info-soft-foreground border-info-dot/30 mx-5 mb-2 rounded-lg border px-3.5 py-2.5 text-xs font-semibold text-pretty"
      }
    >
      {TEXTO_DE_LA_NOTA_DE_TERRENO}
    </p>
  );
}
